import { Component, OnInit } from '@angular/core';
import { ScrambleUnscrambleService } from '../../Services/scramble-unscramble.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { GlobalVariableService } from '../../Shared/global-variable.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpServiceService } from '../../Services/http-service.service';
import { AlertService } from '../../Services/alert.service';
import { MaterialModule } from 'src/app/Shared/Material/material.module';


@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss'],
    standalone: false
})
export class NavComponent implements OnInit {
  navtableDetails: [];
  navtableReport: [];
  displayedColumns: string[] = [ 'NAV_DATE', 'NAV'];
    constructor(private detectorService: DeviceDetectorService,
    private _globalVariableService: GlobalVariableService,
    private spinnerService: NgxSpinnerService,
    private _httpService: HttpServiceService,
    private alertService: AlertService,
    private _scrambleUnscrambleService: ScrambleUnscrambleService,) { }

  ngOnInit() {
      let authid = sessionStorage.getItem("KrCGei");
      var sessionDetails = this._scrambleUnscrambleService.pefundApplyInternalFilter("Unveil", sessionStorage.getItem("ZhJtE" + authid), this._httpService.scrambleKey);
      sessionDetails = JSON.parse(sessionDetails);
      let navDetails: any = {
        "flag":"GET_SCHEME",
        "device_id":this.detectorService.getDeviceInfo().browser,
        "os_id":this.detectorService.getDeviceInfo().os + " - " + this.detectorService.getDeviceInfo().os_version,
        "session_id": sessionDetails[0].sessionid,
        "tax_no":sessionDetails[0].pannumber,
        "amc_code":this._globalVariableService.amc_code
      }
      this.spinnerService.show();
      this._httpService.getNAVDetails(navDetails).subscribe((data) => {
        data = JSON.parse(this._scrambleUnscrambleService.pefundApplyInternalFilter("Unveil", data, this._httpService.unscrambleKey));
        if (data.status.errorflag == true) {
          this.alertService.errorMsg(data.status.errormsg);
        this.spinnerService.hide();
          return;
        } else {
          this.navtableDetails = data.detail
      this.spinnerService.hide();
        }
      });
     
    }
    navtablevalue(value){
      let authid = sessionStorage.getItem("KrCGei");
      var sessionDetails = this._scrambleUnscrambleService.pefundApplyInternalFilter("Unveil", sessionStorage.getItem("ZhJtE" + authid), this._httpService.scrambleKey);
      sessionDetails = JSON.parse(sessionDetails);
      let navDetails: any = {
        "flag":"GET_NAV_DET",
        "device_id":this.detectorService.getDeviceInfo().browser,
        "os_id":this.detectorService.getDeviceInfo().os + " - " + this.detectorService.getDeviceInfo().os_version,
        "session_id": sessionDetails[0].sessionid,
        "tax_no":sessionDetails[0].pannumber,
        "amc_code":this._globalVariableService.amc_code,
        "scheme_code":value
      }
      this.spinnerService.show();
      this._httpService.getNAVDetails(navDetails).subscribe((data) => {
        data = JSON.parse(this._scrambleUnscrambleService.pefundApplyInternalFilter("Unveil", data, this._httpService.unscrambleKey));
        if (data.status.errorflag == true) {
          this.alertService.errorMsg(data.status.errormsg);
        this.spinnerService.hide();
          return;
        } else {
          this.navtableReport = data.detail
          //console.log(data.detail)
      this.spinnerService.hide();
        }
      });

    }
    formatDate(date) {
      var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

      if (month.length < 2)
      month = '0' + month;
      if (day.length < 2)
      day = '0' + day;
      let yeardata = year.toString().replace('-', '')
      return [day, month, yeardata].join('-');
      }
}
